require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/symbol/iterator.js
// module id = 169
// module chunks = 0